import { GiftType, SeaObjectType } from "../types/treasure-hunt";

export const GIFT_NAMES: Record<GiftType, string> = {
  [GiftType.CHEST]: "Подарок / Gift",
  [GiftType.LETTER]: "Сообщение / Message",
  [GiftType.HEART]: "Знакомство / Meeting",
};

export const GIFT_ICONS: Record<GiftType, string> = {
  [GiftType.CHEST]: "/models/treasure-hunt/island-sand-chest.jpg",
  [GiftType.LETTER]: "/models/treasure-hunt/letter.png",
  [GiftType.HEART]: "/models/treasure-hunt/heart.png",
};

export const SEA_OBJECT_NAMES: Record<SeaObjectType, string> = {
  [SeaObjectType.WATER]: "Море (очистить)",
  [SeaObjectType.BOTTLE]: "Бутылка",
  [SeaObjectType.BEAM]: "Балка",
  [SeaObjectType.BOAT]: "Лодка",
  [SeaObjectType.FUNNEL]: "Воронка",
  [SeaObjectType.EDGE_ISLAND_0]: "Край острова 0°",
  [SeaObjectType.EDGE_ISLAND_45]: "Край острова 45°",
  [SeaObjectType.EDGE_ISLAND]: "Край острова",
  [SeaObjectType.SAND_ISLAND]: "Песчаный остров (создать пляж)",
  [SeaObjectType.ISLAND_SAND_CHEST]: "Сундук на суше",
  [SeaObjectType.CHEST_SEA]: "Сундук в море",
  [SeaObjectType.GRASS_EDGE_0]: "Край травы 0°",
  [SeaObjectType.GRASS_EDGE_45]: "Край травы 45°",
  [SeaObjectType.GRASS_EDGE]: "Край травы",
  [SeaObjectType.GRASS]: "Трава",
  [SeaObjectType.TREE]: "Дерево",
  [SeaObjectType.WOMAN_SAND_LIES]: "Женщина на песке",
  [SeaObjectType.WOMAN_SAND_LIES2]: "Женщина на песке 2",
  [SeaObjectType.WOMAN_SEA_LIES]: "Женщина в море",
  [SeaObjectType.MAN_SAND_LIES]: "Мужчина на песке",
  [SeaObjectType.MAN_SEA_LIES]: "Мужчина в море",
  [SeaObjectType.MAN_SAND]: "Мужчина на песке стоя",
  [SeaObjectType.BOTTLE_SAND]: "Бутылка на песке",
  [SeaObjectType.SHIP_LEFT]: "Корабль (левая часть)",
  [SeaObjectType.SHIP_RIGHT]: "Корабль (правая часть)",
  [SeaObjectType.CLOUD]: "Облако",
};

export const SEA_OBJECT_ICONS: Record<SeaObjectType, string> = {
  [SeaObjectType.WATER]: "/models/treasure-hunt/sea.jpg",
  [SeaObjectType.BOTTLE]: "/models/treasure-hunt/bottle-sea.jpg",
  [SeaObjectType.BEAM]: "/models/treasure-hunt/beam-sea.jpg",
  [SeaObjectType.BOAT]: "/models/treasure-hunt/boat-sea.jpg",
  [SeaObjectType.FUNNEL]: "/models/treasure-hunt/funnel-sea.jpg",
  [SeaObjectType.EDGE_ISLAND_0]: "/models/treasure-hunt/edge-island-0.jpg",
  [SeaObjectType.EDGE_ISLAND_45]: "/models/treasure-hunt/edge-island-45.jpg",
  [SeaObjectType.EDGE_ISLAND]: "/models/treasure-hunt/edge-island.jpg",
  [SeaObjectType.SAND_ISLAND]: "/models/treasure-hunt/sand-island.jpg",
  [SeaObjectType.ISLAND_SAND_CHEST]:
    "/models/treasure-hunt/island-sand-chest.jpg",
  [SeaObjectType.CHEST_SEA]: "/models/treasure-hunt/chest-sea.jpg",
  [SeaObjectType.GRASS_EDGE_0]: "/models/treasure-hunt/grass-edge-0.jpg",
  [SeaObjectType.GRASS_EDGE_45]: "/models/treasure-hunt/grass-edge-45.jpg",
  [SeaObjectType.GRASS_EDGE]: "/models/treasure-hunt/grass-edge.jpg",
  [SeaObjectType.GRASS]: "/models/treasure-hunt/grass.jpg",
  [SeaObjectType.TREE]: "/models/treasure-hunt/tree.jpg",
  [SeaObjectType.WOMAN_SAND_LIES]: "/models/treasure-hunt/woman-sand-lies.jpg",
  [SeaObjectType.WOMAN_SAND_LIES2]:
    "/models/treasure-hunt/woman-sand-lies2.png",
  [SeaObjectType.WOMAN_SEA_LIES]: "/models/treasure-hunt/woman-sea-liest.jpg",
  [SeaObjectType.MAN_SAND_LIES]: "/models/treasure-hunt/man-sand-lies.jpeg",
  [SeaObjectType.MAN_SEA_LIES]: "/models/treasure-hunt/man-sea-lies.jpg",
  [SeaObjectType.MAN_SAND]: "/models/treasure-hunt/man-sand.png",
  [SeaObjectType.BOTTLE_SAND]: "/models/treasure-hunt/bottle-sand.jpg",
  [SeaObjectType.SHIP_LEFT]: "/models/treasure-hunt/ship-1:2.jpg",
  [SeaObjectType.SHIP_RIGHT]: "/models/treasure-hunt/ship-2:2.jpg",
  [SeaObjectType.CLOUD]: "/models/treasure-hunt/cloud.jpg",
};

// Предметы, которые можно поворачивать
export const ROTATABLE_OBJECTS = [
  SeaObjectType.BEAM,
  SeaObjectType.BOAT,
  SeaObjectType.EDGE_ISLAND_0,
  SeaObjectType.EDGE_ISLAND_45,
  SeaObjectType.EDGE_ISLAND,
  SeaObjectType.GRASS_EDGE_0,
  SeaObjectType.GRASS_EDGE_45,
  SeaObjectType.GRASS_EDGE,
  SeaObjectType.WOMAN_SAND_LIES,
  SeaObjectType.WOMAN_SAND_LIES2,
  SeaObjectType.WOMAN_SEA_LIES,
  SeaObjectType.MAN_SAND_LIES,
  SeaObjectType.MAN_SEA_LIES,
  SeaObjectType.MAN_SAND,
  SeaObjectType.SHIP_LEFT,
  SeaObjectType.SHIP_RIGHT,
];

// Интерактивные объекты (люди, бутылки, сокровища)
export const INTERACTIVE_OBJECTS = [
  SeaObjectType.BOTTLE,
  SeaObjectType.BOTTLE_SAND,
  SeaObjectType.ISLAND_SAND_CHEST,
  SeaObjectType.CHEST_SEA,
  SeaObjectType.WOMAN_SAND_LIES,
  SeaObjectType.WOMAN_SAND_LIES2,
  SeaObjectType.WOMAN_SEA_LIES,
  SeaObjectType.MAN_SAND_LIES,
  SeaObjectType.MAN_SEA_LIES,
  SeaObjectType.MAN_SAND,
];

// Объекты с возрастом (люди)
export const AGE_OBJECTS = [
  SeaObjectType.WOMAN_SAND_LIES,
  SeaObjectType.WOMAN_SAND_LIES2,
  SeaObjectType.WOMAN_SEA_LIES,
  SeaObjectType.MAN_SAND_LIES,
  SeaObjectType.MAN_SEA_LIES,
  SeaObjectType.MAN_SAND,
];

// Объекты, которые ИГРОК может размещать на воде (только в режиме игры)
export const PLAYER_WATER_OBJECTS = [
  SeaObjectType.BOTTLE,
  SeaObjectType.WOMAN_SEA_LIES,
  SeaObjectType.MAN_SEA_LIES,
];

// Объекты, которые ИГРОК может размещать на песке (только в режиме игры)
export const PLAYER_SAND_OBJECTS = [
  SeaObjectType.BOTTLE_SAND,
  SeaObjectType.MAN_SAND,
  SeaObjectType.MAN_SAND_LIES,
  SeaObjectType.WOMAN_SAND_LIES,
  SeaObjectType.WOMAN_SAND_LIES2,
  // Сундук (ISLAND_SAND_CHEST) запрещен для игроков
];

// Объекты, которые можно размещать только на воде
export const WATER_ONLY_OBJECTS = [
  SeaObjectType.BOTTLE,
  SeaObjectType.CHEST_SEA,
  SeaObjectType.WOMAN_SEA_LIES,
  SeaObjectType.MAN_SEA_LIES,
  SeaObjectType.BEAM,
  SeaObjectType.BOAT,
  SeaObjectType.FUNNEL,
  SeaObjectType.SHIP_LEFT,
  SeaObjectType.SHIP_RIGHT,
];

// Объекты, которые можно размещать только на песке
export const SAND_ONLY_OBJECTS = [
  SeaObjectType.BOTTLE_SAND,
  SeaObjectType.MAN_SAND,
  SeaObjectType.MAN_SAND_LIES,
  SeaObjectType.WOMAN_SAND_LIES,
  SeaObjectType.WOMAN_SAND_LIES2,
  SeaObjectType.ISLAND_SAND_CHEST,
  SeaObjectType.SAND_ISLAND,
  SeaObjectType.EDGE_ISLAND,
  SeaObjectType.EDGE_ISLAND_0,
  SeaObjectType.EDGE_ISLAND_45,
  SeaObjectType.GRASS,
  SeaObjectType.GRASS_EDGE,
  SeaObjectType.GRASS_EDGE_0,
  SeaObjectType.GRASS_EDGE_45,
  SeaObjectType.TREE,
];

export const TILE_SIZE = 35; // Размер клетки в пикселях
export const FIELD_WIDTH = 1920; // Ширина поля в пикселях
export const FIELD_HEIGHT = 1080; // Высота поля в пикселях
export const GRID_COLS = Math.floor(FIELD_WIDTH / TILE_SIZE); // Количество колонок
export const GRID_ROWS = Math.floor(FIELD_HEIGHT / TILE_SIZE); // Количество строк
